export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REMOVE_EXISTING_ALERTS = 'REMOVE_EXISTING_ALERTS';
